<template>
  <container-wrapper v-slot="slotProps" :element-key="elementKey" :element-data="elementData"
    :display-name="'Books' + (isHorizontal ? ' carousel' : '')" icon-name="books">

    <div v-for="(book, index) in elementData.book" class="accordion-item" :key="slotProps.accordionKey + index">
      <highlight-result :element-data="book" :class="getMarkupClasses(book)">

        <div class="accordion-header markup-container markup-container-with-image accordion-item-result"  
          :id="'heading' + slotProps.accordionKey + index">
          <div class="outer-image-wrapper">
            <div class="image-wrapper">
              <img :src="book.desc || defaultBookImage" />
            </div>
          </div>
          <div>
            <span class="ellipsis card-title" v-html="removeYear(book.title)" />
            <span class="ellipsis" v-html="getYear(book.title)" />
          </div>
        </div>

      </highlight-result>
    </div>

  </container-wrapper>
</template>

<script>
import ContainerWrapper from "@/components/card/ContainerWrapper";
import HighlightResult from "@/components/card/HighlightResult.vue";
import { DEFAULT_BOOK_IMAGE } from "@/constants";

export default {
  name: "BooksBox",
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    ContainerWrapper,
    HighlightResult,
  },
  computed: {
    isHorizontal() {
      return this.elementData.orientation == 7;
    }
  },
  data() {
    return {
      defaultBookImage: DEFAULT_BOOK_IMAGE,
    };
  },
  methods: {
    removeYear(text) {
      return (text || '').trim().replace(/\s+\d{4}$/, '');
    },
    getYear(text) {
      const match = (text || '').trim().match(/(\d{4})$/);
      return match ? match[1] : '';
    }
  }

};
</script>
<style lang="scss" scoped>
@import "@/scss/_mixins.scss";

.accordion-item-result {
  overflow: hidden;
}
</style>